import { useTheme } from '@material-ui/core'
import React from 'react'

const ScaleTrianglesIcon = (options = {}) => {
  const theme = useTheme()
  return (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      style={{ flexShrink: 0 }}
    >
      <polygon
        points="0,0 8,0 4,7 0,0"
        fill={
          theme.extras.variables.colors.accentBackground
        }
      ></polygon>
      <polygon
        points="0,16 8,16 4,9 0,16"
        // points="4,9 8,15 0,15 4,9"
        fill={
          theme.extras.variables.colors.accentBackground
        }
      ></polygon>
    </svg>
  )
}

export default ScaleTrianglesIcon
